import { Document as ContentfulDocument } from "@contentful/rich-text-types";

// eslint-disable-next-line
const contentful = require("contentful");

const SPACE = "7rp7y0gd6s4x";
const ENVIRONMENT = "master";

const client = contentful.createClient({
  space: SPACE,
  environment: ENVIRONMENT,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_DELIVERY_API_KEY as string
});

// eslint-disable-next-line
export interface Document extends ContentfulDocument {}

interface File {
  contentType: string;
  filename: string;
  url: string;
}

interface Asset {
  fields: {
    title: string;
    description: string;
    file: File;
  };
}

export interface Service {
  fields: {
    title: string;
    slug: string;
    thumbnail: Asset;
  };
}

interface PostBaseFields {
  bodyHtml: string;
  title: string;
  slug: string;
  body: Document;
  description: string;
  metaDescription: string;
  thumbnail: Asset;
  serviceSlug: string;
  locationSlug: string;
  displayTitle?: string;
}

export interface LocationService {
  sys: { id: string; createdAt: string };
  metadata: {
    tags: Array<{
      sys: {
        id: string;
      };
    }>;
  };
  fields: PostBaseFields;
}

export async function getPosts(options: { [name: string]: string } = {}) {
  const res = await client.getEntries({ content_type: "post", ...options });
  return res.items;
}

export async function getPostById(id: string) {
  const res = await client.getEntry(id);
  return res;
}

export async function getLocationServiceBySlug({
  location,
  service
}: {
  location: string;
  service: string;
}) {
  const res = await client.getEntries({
    limit: 1,
    include: 2,
    content_type: "serviceByLocationApi",
    "fields.serviceSlug": service,
    "fields.locationSlug": location
  });
  return res && res.items.length ? res.items[0] : undefined;
}

export async function getServices() {
  const res = await client.getEntries({
    content_type: "service"
  });
  return res;
}

export async function getLocations() {
  const res = await client.getEntries({
    content_type: "location"
  });
  return res;
}

export async function getLocation(slug: string) {
  const res = await client.getEntries({
    limit: 1,
    include: 1,
    content_type: "location",
    "fields.slug": slug
  });
  return res;
}
